import React, {Fragment, useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import {Alert} from "../../Alert/Alert";
import ProjectInformationDetailForm from "./ProjectInformationDetailForm";
import ProjectInformationEditForm from "./ProjectInformationEditForm";
import PilMaster from "./pilSection/pilMaster";
import moment from "moment";
import {getLockRight, getPILDetails} from "../../../dataSource/pil";

const ProjectInformation = (props) => {
    const store = require("store");
    const dispatch = useDispatch();
    const [tabValue, setTabValue] = useState(0);
    const [editable, setEditable] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [pilDetails, setPilDetails] = useState({});
    const [lock, setLock] = useState(false)
    const [lockRight, setLockRight] = useState(false)
    const [pilStageTwoDetails, setPilStageTwoDetails] = useState({});
    const [updateFlag, setUpdateFlag] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertData, setAlertData] = useState({
        type: "", title: "", content: "",
    });
    const getPil = async () => {
        const response = await getPILDetails();
        setPilDetails(response.data);
        setPilStageTwoDetails(response.data);
        dispatch({
            type: "HANDLE_PIL_VALUE", data: response.data,
        });
    };

    const getLockDataRight = async () => {
        const response = await getLockRight();
        setLockRight(response.data['lock_right'] === 'Y')
    }


    const buildAlert = (data) => {
        setAlertData({
            type: data.type, title: data.title, content: data.content,
        });
        setAlertOpen(true);
    };
    useEffect(() => {
        const getPilFormData = async () => {
            await getPil();
        };
        getPilFormData();
        getLockDataRight()
    }, [updateFlag]);


    useEffect(() => {
        if (pilDetails && pilDetails["general"]) {
            setLock(pilDetails["general"]["lock_data"] === "Y");
        }
    }, [pilDetails])

    const showCheckbox = (code) => {
        let result = "";
        if (pilDetails.natures.nature.indexOf(code) === -1) {
            result = `&#x2610`;
        } else {
            result = `&#9745`;
        }
        return result;
    };
    const showStageTwoCheckBox = (type) => {
        let result = "";
        if (pilDetails.uploadFiles.filter((obj) => obj.type === type && obj.status === "Y").length === 0) {
            result = `&#x2610`;
        } else {
            result = `&#9745`;
        }
        return result;
    };
    const stage2Str = (code, title) => {
        let resultString = ``;
        resultString = `<tr><td>${showStageTwoCheckBox(code)} ${title}</td></tr>`;
        return resultString;
    };
    const showTypeCheckBox = (module, code) => {
        let result = "";
        if (pilDetails[module][code] === "N") {
            result = `&#x2610`;
        } else {
            result = `&#9745`;
        }
        return result;
    };
    const formatDate = (date) => {
        let result = "";
        if (date === null) return result;
        result = moment(date).format("DD/MM/YYYY");
        return result;
    };
    const smToftRatio = Number(10.7639);
    const showUnit = (name, unit) => {
        let result = "";
        if (name !== "") {
            result = unit;
        }
        return result;
    };
    const fieldHeader = (title) => {
        let resultString = ``;
        resultString = `<td><span class="field-label">${title}</span><div class="colon"></div></td>`;
        return resultString;
    };
    const unitString = (title, field, unit) => {
        let resultString = ``;
        resultString = ` <div style="display:flex"><div style="width:40%">${title}</div>
      <div style="width:12%" class="underline2">${field ? field : ``} </div>
      <div style="width:30%;text-align:left">${unit}</div>
      </div>`;
        return resultString;
    };
    const undWithTitleStr = (title, firstName, secondName, nameTitle) => {
        let resultString = ``;
        resultString = `<tr>
     ${fieldHeader(title)}
    <td>
      <div style="display:flex">
        <div class="underline"><div>${firstName ? firstName : ``}</div></div>
          <div style="width:15%"></div>
          <div class="underline"><div>${secondName ? secondName : ``}</div></div>
          <div style="width:15%">${nameTitle}</div>
        </div>
      </div>
    </td>
</tr>`;
        return resultString;
    };
    const dateStr = (title, targetDate, actualDate) => {
        let resultString = ``;
        resultString = `<tr>
            ${fieldHeader(title)}
            <td>
            <div style="display:flex">
              <div class="underline10">
                <div>${formatDate(targetDate)}</div></div>
                <div style="width:30%">(Target)</div>
                <div class="underline10"><div>${formatDate(actualDate)}</div></div>
                <div style="width:30%">(Actual)</div>
                </div>
              </div>
            </td>
        </tr>
  <tr>`;
        return resultString;
    };
    const multipleDateStr = (targetDate, actualDate) => {
        let resultString = ``;
        resultString = `<div style="height:18px"><div style="display:flex">
                  <div class="underline10"><div>${formatDate(targetDate)}</div></div>
            <div style="width:30%">(Target)</div>
            <div class="underline10">
            <div>${formatDate(actualDate)}</div>
            </div>
            <div style="width:30%">(Actual)</div>
            </div>
            </div></div>`;
        return resultString;
    };
    const undStr = (title, field) => {
        let resultString = ``;
        resultString = `<tr>${fieldHeader(title)}<td><div class="underline"><span>${field ? field : ``}</span></div></td></tr>`;
        return resultString;
    };
    let htmlStr = pilDetails.general && pilDetails.details && `<html>
  <style>
  body {
    font-family: Arial;
    font-size: 10px;
    margin: 0;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
  }
  .headerClass th, td {
      position: relative;
      border-collapse: collapse;
      padding: 4px; 
      vertical-align: bottom;  
  }
  .headerClass tr td:first-child {
        width: 300px;
        vertical-align: top;
    }
.signature{
      width: 100%;
      display: flex;
}
  .signature div:last-child::after {
    content: "General Manager";
    font-weight: bold;

}
 .colon {
      position: absolute;
      top: 2px;
      right: 2px;
  }
  .colon::before {
      content: ":"
  }
  .underline {
     border-bottom: 1px solid black;
     width: 100%;
     text-align:center;
     word-wrap: break-word;
     
  }
  .underline10 {
    border-bottom: 1px solid black;
    width: 95%;
    text-align:center;
    word-wrap: break-word;
    
 }
  .underline2 {
    border-bottom: 1px solid black;
    width: 100%;
    text-align:center;
    word-wrap: break-word;
 }
 .underline3 {
  border-bottom: 1px solid black;
  width: 200px;
  text-align:center;
  word-wrap: break-word;
}
.multi-underline {
  max-width: 350px;
}
.person-table{
  border-collapse: collapse;
  width: 100%;
}
.pic-table{
  border-collapse: collapse;
  width: 100%;
}
.stage2-table{
  border-collapse: collapse;
  width: 50%;

}
.stage2-table td, th {
  border: 1px solid black;
  text-align: left;
  padding: 8px;
}
/*.stage2-table tr:last-child td{*/
/*  border: 0 !important;*/
/*  text-align: left;*/
/*  padding: 8px;*/
/*}*/
.person-table td, th {
   width: 33.3%;
  border: 1px solid black;
  text-align: left;
  padding: 8px;
}
.pic-table th:first-child{
  width:218px;
}
.pic-table th:last-child{
  width:218px;
}
.STAGEDIVIDER{
  margin: 40px 0 40px 0;
}
.multi-underline span {
  display: block;
  font-size: 10px;
  line-height: 10px;
  background-image: repeating-linear-gradient(to bottom,
          rgb(255, 255, 255),
          rgb(255, 255, 255) calc(10px - 1px),
          rgb(0, 0, 0) 10px);
}
.field-label {
      font-weight: bold;
}
.headerContainer{
    width: 33.33%;
}
</style>
  <head>
  <meta charset="utf-8">
  <style>     
        @media print{ 
        .pagebreak { page-break-before: always;} 
        }
        @page{
          size: A4;
          margin: 80px 30px 65px 60px;
          @bottom-right {
            margin-right: 20px;
            font-size: 10px;
            content: counter(page) ' of ' counter(pages);
          }  
          @top-left {
            margin-left: 20px;
            font-size: 10px;
            content: '${store.get("site_code")}';
          }  
          @top-center {
            margin-right: 20px;
            font-size: 10px;
            content: 'Project Data';
            text-decoration:underline;
          }  
          @top-right {
            margin-right: 20px;
            font-size: 10px;
            content: 'Date: ${moment(new Date()).format("DD/MM/YYYY")}';
          }  
        }
        @body{
          word-wrap: break-word;
        }
</style>
</head>
    <body>
    <div style="word-wrap: break-word;">
        <table class="headerClass" style="width:100%">
        ${undStr("Site Code", store.get("site_code"))}
        ${undStr("Name of Project", pilDetails.general.name)}
        ${undStr("Name of Estate/Development", pilDetails.general.estate_name)}
        <tr>
        ${fieldHeader("Lot No.")}
        <td>
        <div class="underline">
          <span>${pilDetails.details.lot_no ? pilDetails.details.lot_no : ``} ${pilDetails.details.lot_no_code ? `(${pilDetails.details.lot_no_code})` : ``}</span>
        </div>           
        </td>
    </tr>
     ${undStr("GBP", pilDetails.details.gbp)}
    <!--       
     <tr>
     ${fieldHeader("Coordinates pf Point X Y Z")}
    <td>
            <div style="display:flex">
            <div style="font-weight: 700">X</div>
            <div style="margin-left: 5px">:</div>
            <div class="underline" style="margin-right: 3%">
              <div>${pilDetails.details.cop_x ? pilDetails.details.cop_x : ``}</div>
              </div>
            <div style="font-weight: 700">Y</div>
            <div style="margin-left: 5px">:</div>
            <div class="underline" style="margin-right: 3%">
            <div >${pilDetails.details.cop_y ? pilDetails.details.cop_y : ``}</div>
              </div>
              <div style="font-weight: 700">Z</div>
              <div style="margin-left: 5px">:</div>
              <div class="underline">
              <div >${pilDetails.details.cop_z ? pilDetails.details.cop_z : ``}</div>
              </div>
              </div>
              
          </div>
     </td>
    </tr>
     -->
    <tr>
      ${fieldHeader("Site Area(s.m & s.ft.)")}
      <td>
      <div class="underline">
      <span>${pilDetails.areas.site_area_1} ${showUnit(pilDetails.areas.site_area_1, "s.m.")} ${pilDetails.areas.site_area_1 !== "" ? `(${(pilDetails.areas.site_area_1 * smToftRatio).toFixed(2)} ${showUnit(pilDetails.areas.site_area_1, "s.ft.")})` : ``}</span>
      </div>           
      </td>
    </tr>
    <tr>
    ${fieldHeader("Gross Floor Area(s.m & s.ft.)")}
      <td>
      <div class="underline">
      <span>${pilDetails.areas.gfa_total} ${showUnit(pilDetails.areas.gfa_total, "s.m.")} ${pilDetails.areas.gfa_total !== "" ? `(${(pilDetails.areas.gfa_total * smToftRatio).toFixed(2)} ${showUnit(pilDetails.areas.gfa_total, "s.ft.")})` : ``}</span>
      </div>           
      </td>
    </tr>
    <tr>
      <td>
          <span class="field-label" style="padding-left:30px">Domestic Gross Floor Area(s.m & s.ft.)</span>     
      </td>
      <td>
      <div class="underline">
        <span>${pilDetails.areas.domestic_gfa} ${showUnit(pilDetails.areas.domestic_gfa, "s.m.")} ${pilDetails.areas.domestic_gfa !== "" ? `(${(pilDetails.areas.domestic_gfa * smToftRatio).toFixed(2)} ${showUnit(pilDetails.areas.domestic_gfa, "s.ft.")})` : ``}</span>
      </div>           
      </td>
    </tr>
    <tr>
      <td>
          <span class="field-label" style="padding-left:30px">Non-domestic Gross Floor Area(s.m & s.ft.)</span>
      </td>
      <td>
      <div class="underline">
        <span>${pilDetails.areas.nondomestic_gfa} ${showUnit(pilDetails.areas.nondomestic_gfa, "s.m.")} ${pilDetails.areas.nondomestic_gfa !== "" ? `(${(pilDetails.areas.nondomestic_gfa * smToftRatio).toFixed(2)} ${showUnit(pilDetails.areas.nondomestic_gfa, "s.ft.")})` : ``}</span>
      </div>           
      </td>
    </tr>
    <tr>
    ${fieldHeader("Construction Floor Area(s.m & s.ft.)")}
      <td>
      <div class="underline">
      <span>${pilDetails.areas.cfa_total} ${showUnit(pilDetails.areas.cfa_total, "s.m.")} ${pilDetails.areas.cfa_total !== "" ? `(${(pilDetails.areas.cfa_total * smToftRatio).toFixed(2)} ${showUnit(pilDetails.areas.cfa_total, "s.ft.")})` : ``}</span>
      </div>           
      </td>
    </tr>
    <tr>
     ${fieldHeader("Nature of Project")}
      <td>
      <div style="display:flex">
        <div style="width:40%">Residential</div>
        <div style="width:10%">${showCheckbox("RESD")}</div>
        <div style="width:40%">Retail</div>
        <div style="width:10%">${showCheckbox("RET")}</div>     
      </div>
      <div style="display:flex">
        <div style="width:40%">Office</div>
        <div style="width:10%">${showCheckbox("OFF")}</div>
        <div style="width:40%">Industrial</div>
        <div style="width:10%">${showCheckbox("IND")}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">Hotel</div>
        <div style="width:10%">${showCheckbox("HOT")}</div>
        <div style="width:40%">Data Centre</div>
        <div style="width:10%">${showCheckbox("DA")}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">A&A Works</div>
        <div style="width:10%">${showCheckbox("AA")}</div>
        <div style="width:40%">Others</div>
        <div style="width:10%">${showCheckbox("OTHERS")} </div>
      </div>   
      <div>
      ${showCheckbox("AA") === "&#9745" ? pilDetails.natures.aaworks
        .map((obj, index) => `<div style="display:flex">
                      <div class="underline3">${obj.description}</div>
                      <div style="width:15%"></div>
                      ${index === 0 ? `<div class="underline3">${pilDetails.natures.natureother ? pilDetails.natures.natureother : ``}</div>` : ``}
                  </div>`)
        .join(``) : `<div style="display:flex"><div class="underline3"></div><div style="width:15%"></div><div class="underline3">${pilDetails.natures.natureother ? pilDetails.natures.natureother : ``}</div>`}
          
      </div> 
      </td>
    </tr>
    <tr>
     ${fieldHeader("No. of Blocks & Storey")}
    <td>
      <div style="width: 100%">
      <div class="underline"> 
      <span style="white-space:normal">${pilDetails.details.no_blocks || ""}</span>
      </div>
      </div>
              
    </td>
</tr>
<tr>
 ${fieldHeader("No. of Residential Units")}
    <td>  
      ${unitString("Tower", pilDetails.general.tower, "Units")}
      ${unitString("Villa", pilDetails.general.villa, "Units")}
      ${unitString("House", pilDetails.general.house, "Units")}  
    </td>
</tr>
<tr>
${fieldHeader("No. of Carpark")}
<td>
    ${unitString("Residential Carpark", pilDetails.general.rescarpark, "No.")}    
    ${unitString("Commercial Carpark", pilDetails.general.comcarpark, "No.")}  
    ${unitString("Visitor Carpark", pilDetails.general.visitorcarpark, "No.")} 
    ${unitString("Motorcycle", pilDetails.general.motor, "No.")} 
    ${unitString("Bicycle", pilDetails.general.bicycle, "No.")}
    ${unitString("Loading/Unloading Bay", pilDetails.general.loading, "No.")}
    ${unitString("Public Vehicle Carpark", pilDetails.general.publicvehicle, "No.")}     
    ${unitString("LGV/HGV/Coach Parking", pilDetails.general.lgv, "No.")} 
</td>
</tr>
<tr>
            ${fieldHeader("BeamPlus Rating (Target/Actual)")}
            <td>
            <div style="display:flex">
            <div class="underline10">
              <div>${pilDetails.details.target_beam_rating ? pilDetails.details.target_beam_rating : ``}</div>
              </div>
              <div style="width:30%">(Target)</div>
              <div class="underline10">
              <div >${pilDetails.details.actual_beam_rating ? pilDetails.details.actual_beam_rating : ``}</div>
              </div>
              <div style="width:30%">(Actual)</div>
              </div>
              </div>
            </td>
        </tr>
        ${dateStr("Commencement Date", pilDetails.details.target_commencement_date, pilDetails.details.actual_commencement_date)}
        ${dateStr("Site Formation Commencement Date", pilDetails.details.target_site_form_date, pilDetails.details.actual_site_form_date)}
        ${dateStr("Cap Commencement Date", pilDetails.details.target_cap_form_date, pilDetails.details.actual_cap_form_date)}
        ${dateStr("Occupation Permit Date", pilDetails.details.target_op_date, pilDetails.details.actual_op_date)}
  <tr>
   ${fieldHeader("Phased Occupation Permit Date(s)")}
  <td>
  ${pilDetails.phaseOp.filter((a) => a.status === "Y").length > 0 ? pilDetails.phaseOp
        .filter((a) => a.status === "Y")
        .map((obj) => multipleDateStr(obj.target_date, obj.actual_date))
        .join(``) : multipleDateStr(null, null)}
  </td>
</tr>
${dateStr("Practical Completion Date", pilDetails.details.target_practical_com_date, pilDetails.details.actual_practical_com_date)}
<tr>
${fieldHeader("Sectional Completion Date(s)")}
        <td>
        ${pilDetails.secCom.filter((a) => a.status === "Y").length > 0 ? pilDetails.secCom
        .filter((a) => a.status === "Y")
        .map((obj) => multipleDateStr(obj.target_date, obj.actual_date))
        .join(``) : multipleDateStr(null, null)}
        </td>
        ${dateStr("Consent to Assign Date(CTOA)", pilDetails.details.target_consent_assign_date, pilDetails.details.actual_consent_assign_date)}
        ${dateStr("Certificate of Compliance Date", pilDetails.details.target_cc_date, pilDetails.details.actual_cc_date)}
         ${dateStr("Building Covenant Date", pilDetails.details.target_bc_date, pilDetails.details.actual_bc_date)}
    <tr>
    ${fieldHeader("Defect Liability Period")}
    <td>
    <div style="display:flex">
    <div style="width:35%">
        <div>12 / 16 Months</div>
      </div>
      <div style="width:15%">${showTypeCheckBox("details", "DEFECT12")}</div>
      <div style="width:35%">
      <div>3 Years</div>
      </div>
      <div style="width:15%">${showTypeCheckBox("details", "DEFECT3YEARS")}
      </div>
    </div>
    </div>          
    </td>
  </tr>
      ${undStr("Project Phasing(if any)", pilDetails.details.proj_phasing)}
      ${undStr("Name of Developer", pilDetails.details.developer_name)}
      ${undStr("Client Project Manager(CPM)", pilDetails.details.client_proj_manager)}
    <tr>
     ${fieldHeader("Technical Director & Authorised Signatory(BD)")}
    <td>
            <div style="display:flex">
            <div class="underline">
              <div>${pilDetails.details.technical_director ? pilDetails.details.technical_director : ``}</div>
              </div>
              <div style="width:15%">(BD-TD)</div>
              <div class="underline">
              <div >${pilDetails.details.authorised_signatory ? pilDetails.details.authorised_signatory : ``}</div>
              </div>
              <div style="width:15%">(BD-AS)</div>
              </div>
              </div>
            </td>
</tr>
    <tr>
     ${fieldHeader("Design Architect")}
    <td>
    <div class="underline">
      <span>${pilDetails.details.design_architect ? pilDetails.details.design_architect : ``}</span>
    </div>           
    </td>
</tr>
      ${undWithTitleStr("Architecture, AP", pilDetails.details.architect, pilDetails.details.architect_ap, "(BD-AP)")}
      ${undWithTitleStr("Structural Consultant, (RSE)", pilDetails.details.structural_consultant, pilDetails.details.structuralconsultant_rse, "(BD-RSE)")}
    ${undStr("M&E Consultant", pilDetails.details.me_consultant)}
    ${undWithTitleStr("Geotechnical Consultant, (RGE)", pilDetails.details.geo_consultant, pilDetails.details.geoconsultant_rge, "(BD-RGE)")}
${undStr("Landscape Consultant", pilDetails.details.landscape_architect)}
${undStr("Interior Designer/Consultant", pilDetails.details.interior_designer)}
${undStr("Sustainability / BeamPlus Consultant", pilDetails.details.beamplus_consultant)}
${undStr("Quantity Surveying Consultant", pilDetails.details.qs_consultant)}
 ${fieldHeader("Other Consultant(s)")}
  <td>
  ${pilDetails.otherConsultant.length > 0 ? pilDetails.otherConsultant
        .map((obj) => `<div style="min-height:20px"><div style="display:flex;flex-wrap: nowrap;align-items: flex-end;min-height:20px">
            <div class="underline10">
      <div >${obj.title}</div>
      </div>
      <div style="width:25%">(Title)</div>
      <div class="underline10">
      <div style=" width: 100%">${obj.name}</div>
      </div>
      <div style="width:25%">(Name)</div>
      </div>
      </div></div>`)
        .join("") : `<div style="display:flex"><div class="underline10">
      <div></div>
      </div>
      <div style="width:25%">(Title)</div>
      <div class="underline10">
      <div></div>
      </div>
      <div style="width:25%">(Name)</div>
      </div>
      </div>
      </div>`}
  </td>
</tr>
<tr>
${fieldHeader("CPM (Client Project Manager)")}
  <td>
  ${pilDetails.cpms.length > 0 ? pilDetails.cpms
        .filter((a) => a.full_name !== null)
        .map((obj) => `<div style="min-height:20px"><div style="display:flex;flex-wrap: nowrap;align-items: flex-end;min-height:20px">
            <div class="underline10">
          <div>${obj.full_name}</div>
          </div>
      <div style="width:25%">(Name)</div>
      <div class="underline10">
        <div >${obj.email ? obj.email : ""}</div>
      </div>
        <div style="width:25%">(Email)</div>
      </div>
      </div></div>`)
        .join("") : `<div><div style="display:flex">
            <div class="underline10">
          <div></div>
          </div>
      <div style="width:25%">(Name)</div>
      <div class="underline10">
        <div ></div>
      </div>
        <div style="width:25%">(Email)</div>
      </div>
      </div></div>`}
  </td>
</tr>
${undStr("Estate Management", pilDetails.details.estate_management)}
${undStr("Main Contractor", pilDetails.details.main_contractor)}
${pilDetails.pics.length > 0 ? `<table class="pic-table">
      <tr>  
          <th>Name of PIC (Project in Charge)</th>
      </tr>
       <tr>      
          <th style="font-weight:normal">${pilDetails.pics[0].english_name}</th>
      </tr>
</table>` : `<table class="pic-table">
     <tr>  
          <th>Name of PIC (Project in Charge)</th>
      </tr>
       <tr>      
          <th></th>
      </tr>
      </table>`}
<br />
${pilDetails.sics.length > 0 && pilDetails.sics[0].proj_phasing ? `<table class="person-table">
      <tr>  
          <th>Project Phasing</th>
          <th>Name of SIC (Site in Charge)</th>
          <th>Finance Project Code(to be assigned by accounting team)</th>
          <th>Finance Sub Project Code(to be assigned by accounting team)</th>
      </tr>
     ${pilDetails.sics
        .map((obj) => {
            return `<tr>
          <td>${obj.proj_phasing}</td>
          <td>${obj.english_name}</td>
          <td>${obj.orcl_code ? obj.orcl_code : ""}</td>
          <td>${obj.orcl_sub_code ? obj.orcl_sub_code : ""}</td>
     </tr>`;
        })
        .join(``)}
</table>` : `<table class="person-table">
      <tr>  
          <th>Name of SIC (Site in Charge)</th>
          <th>Finance Project Code(to be assigned by accounting team)</th>
          <th>Finance Sub Project Code(to be assigned by accounting team)</th>
      </tr>
          ${pilDetails.sics
        .map((obj) => {
            return `<tr>
          <td>${obj.english_name}</td>
          <td>${obj.orcl_code ? obj.orcl_code : ""}</td>
          <td>${obj.orcl_sub_code ? obj.orcl_sub_code : ""}</td>
     </tr>`;
        })
        .join(``)}
      </table>`}
 <table class="headerClass" style="width:100%" >
${undStr("Cost Control Leader(Accounting Manager)", pilDetails.details.accounting_manager)}
 ${undStr("Cost Control Leader(Quantity Surveying Manager)", pilDetails.details.quantity_survey_manager)}
${undStr("Cost Control Leader(Contracts Manager)", pilDetails.details.contracts_manager)}
<tr>
${fieldHeader("Type of Contract")}
<td>  
      <div style="display:flex">
        <div style="width:40%">In-house(Internal Project)</div>
        <div style="width:10%">${showTypeCheckBox("contract", "INHOUSE")}</div>
        <div style="width:40%">Cost plus(Project Markup)</div>
        <div style="width:10%">${pilDetails.contract.INCOST ? pilDetails.contract.INCOST + "%" : ``}</div>
      </div>
      <div style="display:flex">
      <div style="width:40%">JV(External Project)</div>
      <div style="width:10%">${showTypeCheckBox("contract", "JV")}</div>
      <div style="width:40%">Cost plus(Project Markup)</div>
      <div style="width:10%">${pilDetails.contract.JVCOST ? pilDetails.contract.JVCOST + "%" : ``}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">Tender Project</div>
        <div style="width:60%">${showTypeCheckBox("contract", "TEN")}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">Lump Sum</div>
        <div style="width:60%">${showTypeCheckBox("contract", "LUMP")}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">Others</div>
        <div class="underline">${pilDetails.contract.OTHERSREMARK ? pilDetails.contract.OTHERSREMARK : ``}</div>
        <div style="width:10%">${showTypeCheckBox("contract", "OTHER")}</div>
        </div>
      </div>           
      </td>
</tr>
<tr>
${fieldHeader("Payment Term")}
<td>
      <div style="display:flex">
        <div style="width:40%">Monthly Progress Payment</div>
        <div style="width:60%">${showTypeCheckBox("paymentTerm", "MONTHS")}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">Scheduled Payment</div>
        <div style="width:60%">${showTypeCheckBox("paymentTerm", "SCH")}</div>
      </div>
      <div style="display:flex">
        <div style="width:40%">Architect Certificate</div>
        <div style="width:10%">${showTypeCheckBox("paymentTerm", "ARCH")}</div>
        ${pilDetails.paymentTerm.ARCH === "Y" ? `<div style="width:35%">
              ${pilDetails.paymentTerm.PERIOD ? pilDetails.paymentTerm.PERIOD : ``}
              Days
            </div>` : ``}
      </div>  
        </div>
      </div>           
      </td>
</tr>
<tr>
${fieldHeader("Remark")}
    <td>
    <div style="display:flex">
    <div class="multi-underline">
      <span>${pilDetails.details.remark ? pilDetails.details.remark : ``}</span>
    </div>  
    </div>         
    </td>
</tr>
</table>
    <div style="display:none">%SIGNATURE%</div>
    <div class="STAGEDIVIDER" />

 ${pilDetails.uploadFiles.filter((obj) => obj.stage === "1" && obj.status === "Y").length > 0 ? ` <div class="pagebreak" /><table class="stage2-table">
            <tr>
              <th>Annexes to Project Information List</th>
            </tr>
  ${stage2Str("ochart", "1.  O-Chart and Manpower Schedule")} 
  ${stage2Str("tender", "2.  Tender and Dessign Information Schedule")}  
  ${stage2Str("tempwork", "3.  Temporary work Schedule")}  
  ${stage2Str("plant", "4.  Plant Schedule")}     
  ${stage2Str("others", "5.  others")}         
  <!--
  <tr>
              <td>
                <span style="padding-left:13px">5.  Preliminart Budget Esitmate HK$${pilDetails.details.pre_budget ? pilDetails.details.pre_budget : ``} per sq.ft. of GFA</span>
              </td>
            </tr>
  -->  
            
        </table>` : ""

    }
 
   <div style="display:none">%SIGNATURE2%</div>
    </body>
  </html>`;
    return (<Fragment>
        <Alert
            open={alertOpen}
            alertType={alertData.type}
            alertTitle={alertData.title}
            alertContent={alertData.content}
            handleClose={() => setAlertOpen(false)}
        />
        <PilMaster
            editable={editable}
            setEditable={setEditable}
            openDialog={openDialog}
            lock={lock}
            lockRight={lockRight}
            setOpenDialog={setOpenDialog}
            pilDetails={pilDetails}
            setUpdateFlag={setUpdateFlag}
            htmlStr={htmlStr}
        />
        {editable ? (<ProjectInformationEditForm
            editable={editable}
            pilDetails={pilDetails}
            setPilDetails={setPilDetails}
            setEditable={setEditable}
            buildAlert={buildAlert}
            tabValue={tabValue}
            lock={lock}
            lockRight={lockRight}
            updateFlag={updateFlag}
            pilStageTwoDetails={pilStageTwoDetails}
            setUpdateFlag={setUpdateFlag}
            htmlStr={htmlStr}
        />) : (<ProjectInformationDetailForm
            editable={editable}
            tabValue={tabValue}
            setTabValue={setTabValue}
            pilDetails={pilDetails}
            htmlStr={htmlStr}
        />)}
    </Fragment>);
};

export default ProjectInformation;
